export const Lang = {
  title: 'St. Andrews Links Bookings',
};
